export default __webpack_public_path__ + "static/media/condo_light.d3e1a41e.png";